let Components = {}

Components['ProductDefault'] = require('./ProductDefault').default;
Components['ProductGiodicart'] = require('./ProductGiodicart').default;

export default Components